export default "__VITE_ASSET__CnLJPDdR__"